/**
 * DoubleReplic mixin
 *
 * Миксин помогает решить проблему неисполнения скрипта
 * К любому произношению робота может быть прикреплен скрипт (например помахать рукой)
 * Если в этот момент попытаться выполнить другой скрипт - он будет проигнорирован
 *
 * https://git.promo-bot.ru/ds/promobot-api/-/snippets/28
 *
 */

const SCRIPT_STEPS = Object.freeze({
  PASS: 'pass',
  STOP: 'stop',
  STOPPED: 'stopped',
});

export default {
  staticData: () => ({
    scriptStep: '',
    scriptEndTimeout: null,
    replicTimeout: null,
    sayReplicFunction: () => 0,
  }),
  created() {
    this.initDoubleReplicActions();
  },
  methods: {
    sayDoubleReplic(replicOne, replicTwo) {
      this.stopScriptAndSayReplicByName(replicOne);
      this.replicTimeout = window.setTimeout(() => {
        const unsubscribe = this.$robot.dialogService.onRobotReplicFinish(() => {
          this.$robot.dialogService.sayReplicByName(replicTwo, true);
          unsubscribe();
        });
      }, 1500);
    },
    stopScriptAndSayReplicByName(name, terminate = true) {
      this.$robot.scriptsService.stopScript();
      this.scriptStep = SCRIPT_STEPS.STOP;
      this.sayReplicFunction = () => {
        this.scriptStep = SCRIPT_STEPS.STOPPED;
        this.$robot.dialogService.sayReplicByName(name, terminate);
      };
      this.scriptEndTimeout = window.setTimeout(this.sayReplicFunction, 1000);
    },
    onScriptEnd() {
      if (this.scriptStep === SCRIPT_STEPS.STOP) {
        this.clearScriptTimeout();
        this.sayReplicFunction?.(); // eslint-disable-line
        return;
      }
      if (this.scriptStep === SCRIPT_STEPS.STOPPED) {
        this.scriptStep = SCRIPT_STEPS.PASS;
      }
    },
    clearScriptTimeout() {
      window.clearTimeout(this.scriptEndTimeout);
    },
    clearReplicTimeout() {
      window.clearTimeout(this.replicTimeout);
    },
    initDoubleReplicActions() {
      const robotActions = [
        this.$robot.scriptsService.onScriptEnd(this.onScriptEnd),
      ];

      this.$once('hook:beforeDestroy', () => {
        robotActions.forEach((unsubscribe) => unsubscribe());
        this.clearScriptTimeout();
        this.clearReplicTimeout();
      });
    },
  },
};
